// extracted by mini-css-extract-plugin
export var actions = "_g1-g";
export var benefitCard = "_g1-b";
export var benefitIcon = "_g1-d";
export var benefitLabel = "_g1-f";
export var benefits = "_g1-a";
export var benefitsSection = "_g1-8";
export var bodyText = "_g1-7";
export var closeButton = "_g1-2";
export var content = "_g1-3";
export var eyebrow = "_g1-4";
export var heading = "_g1-5";
export var image = "_g1-i";
export var imagePanel = "_g1-h";
export var modal = "_g1-0";
export var offerCard = "_g1-c";
export var offerIcon = "_g1-e";
export var sectionLabel = "_g1-9";
export var shell = "_g1-1";
export var title = "_g1-6";